interface LogoProps {
  size?: number;
  showText?: boolean;
  className?: string;
}

export function Logo({ size = 32, showText = true, className = '' }: LogoProps) {
  const fontSize = 16;

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Bosphorus Labs"
      >
        <path
          fill="url(#logoGradient)"
          d="M64.188 10.172c5.582 0 10.542 3.937 10.542 8.785 0 4.848-4.722 8.785-10.543 8.785-.664 0-1.53-.11-2.601-.328a3.51 3.51 0 0 0-2.438.39L21.355 49.298a1.76 1.76 0 0 0 .008 3.062l40.969 22.996a3.517 3.517 0 0 0 3.426.012l41.187-22.898a1.752 1.752 0 0 0 .016-3.063l-12.852-7.293a3.517 3.517 0 0 0-3.441-.02l-13.563 7.524a1.21 1.21 0 0 0-.613.918l-.004.13c0 4.85-4.722 8.784-10.543 8.784-5.816 0-10.539-3.933-10.539-8.785 0-4.848 4.723-8.785 10.54-8.785.218 0 .464.016.745.035l.446.047.492.059c.75.101 1.512-.04 2.176-.407l20.065-11.13a5.266 5.266 0 0 1 4.945-.086l.215.11 28.016 15.906c3.512 1.992 3.55 7.012.144 9.082l-.187.11-18.746 10.417a1.763 1.763 0 0 0-.899 1.559c.012.645.371 1.23.938 1.531l18.562 9.766c3.688 1.937 3.774 7.183.16 9.242L66.642 120.25a5.284 5.284 0 0 1-5.227 0L5.36 88.254c-3.62-2.067-3.52-7.324.176-9.25l18.766-9.79a1.761 1.761 0 0 0 .047-3.093L5.355 55.461c-3.511-1.973-3.585-6.969-.21-9.066l.187-.114 46.645-26.523a3.533 3.533 0 0 0 1.578-1.89l.058-.188c1.64-4.875 5.364-7.508 10.575-7.508Zm26.027 64.715L67.184 88.129l-.215.117a5.25 5.25 0 0 1-4.98-.094L39.03 75.207a3.503 3.503 0 0 0-3.343-.05l-13.235 6.917a1.759 1.759 0 0 0-.055 3.086l40.434 23.137a3.515 3.515 0 0 0 3.477 0l40.78-23.3c.56-.317.9-.915.891-1.556a1.759 1.759 0 0 0-.94-1.527L93.593 74.82a3.509 3.509 0 0 0-3.38.067Zm0 0"
        />
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#A78BFA" />
            <stop offset="50%" stopColor="#8B5CF6" />
            <stop offset="100%" stopColor="#7C3AED" />
          </linearGradient>
        </defs>
      </svg>

      {showText && (
        <span
          className="font-semibold tracking-tight"
          style={{ fontSize }}
        >
          <span className="bg-gradient-to-r from-purple-400 to-violet-500 bg-clip-text text-transparent">
            Bosphorus
          </span>
          <span className="text-purple-300/90 font-medium ml-1">
            Labs
          </span>
        </span>
      )}
    </div>
  );
}
